'use strict';
angular
    .module('mainModule', [
        'homePageModule', //首页
        'submissionManageModule', //投稿管理
        'settingsModule', //设置
        'backstageModule', //后台,
        'fullSearchModule' // 全文检索
    ])
    .run(['modalDialog', function (modalDialog) {}]);
